import { render, staticRenderFns } from "./PedidoDeCompraAlterarPedidoDeCompraView.vue?vue&type=template&id=cd577f5e&scoped=true"
import script from "./PedidoDeCompraAlterarPedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraAlterarPedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraAlterarPedidoDeCompraView.vue?vue&type=style&index=0&id=cd577f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd577f5e",
  null
  
)

export default component.exports